import { render, staticRenderFns } from "./BAccordion.vue?vue&type=template&id=15087b7f&"
import script from "./BAccordion.vue?vue&type=script&lang=ts&"
export * from "./BAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports